import React from 'react';

// Icon Components
export const VolumeOverloadIcon: React.FC = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 12L24 4L40 12V28C40 36.8366 32.8366 44 24 44C15.1634 44 8 36.8366 8 28V12Z" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 16L24 10L36 16" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 20L24 14L36 20" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 24L24 18L36 24" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ManualTasksIcon: React.FC = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" stroke="#72d6ff" strokeWidth="2"/>
    <path d="M24 12V24L32 28" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="24" cy="24" r="2" fill="#72d6ff"/>
  </svg>
);

export const KnowledgeLossIcon: React.FC = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round"/>
    <path d="M24 14V24L30 30" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38 10L42 14L38 18" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M42 14H32" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const EscalatingCostsIcon: React.FC = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 36L16 28L24 32L40 16" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M32 16H40V24" stroke="#72d6ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="16" cy="28" r="2" fill="#72d6ff"/>
    <circle cx="24" cy="32" r="2" fill="#72d6ff"/>
    <circle cx="40" cy="16" r="2" fill="#72d6ff"/>
  </svg>
);
